/* Aximyra mix-and-match storefront — no checkout price overrides. */
(function(){
  function init(){
    var root=document.getElementById("axm-bundle");
    if(!root||root.dataset.bound==="1")return;
    root.dataset.bound="1";
    var dataEl=document.getElementById("axm-bundle-products");
    var typeOptions=[{value:"near",label:"근시용 (−)"},{value:"reading",label:"독서용 (+)"}];
    var list={near:[],reading:[]},currentQty=3,tier=3,adding=false;
    var rows=root.querySelector("[data-axm-rows]");
    var totalEl=root.querySelector("[data-axm-total]");
    var compareEl=root.querySelector("[data-axm-original]");
    var quantityWrap=root.querySelector("[data-axm-quantity]");
    var status=root.querySelector("[data-axm-status]");
    var submit=root.querySelector("[data-axm-add]");
    var buyNow=root.querySelector("[data-axm-buy-now]");
    if(!buyNow)return;
    var selectStates=[];
    var prices={1:2999,2:3999,3:4999,4:5999};
    var currency=function(c){return "$"+(c/100).toFixed(2)};
    var esc=function(s){return String(s||"").replace(/[&<>"']/g,function(ch){return {"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#39;"}[ch]})};
    try{
      var raw=JSON.parse(dataEl.textContent||"{}");
      ["near","reading"].forEach(function(kind){
        var p=raw[kind];if(!p||!p.variants)return;
        list[kind]=p.variants.filter(function(v){return v.available!==false}).map(function(v){
          var label=String(v.option1||v.title||"").trim();
          return {id:Number(v.id),label:label,available:v.available!==false};
        }).filter(function(v){return /^[+\-\u2212]\d+\.\d{2}$/.test(v.label)&&v.id>0});
      });
    }catch(e){status.textContent="렌즈 옵션을 불러오지 못했습니다. 페이지를 새로고침해 주세요.";}
    if(!list.near.length||!list.reading.length){
      status.textContent="렌즈 옵션이 표시되지 않으면 새로고침하거나 고객센터로 문의해 주세요.";
      submit.disabled=true;
      return;
    }
    function resetStates(){
      while(selectStates.length<currentQty)selectStates.push({kind:selectStates.length%2===0?"near":"reading",id:null});
      selectStates.length=currentQty;
    }
    function price(){return tier===5?currentQty*1499:prices[tier]}
    function powers(kind,selected){
      return list[kind].map(function(v){return '<option value="'+v.id+'"'+(String(selected)===String(v.id)?" selected":"")+'>'+esc(v.label)+'</option>'}).join("");
    }
    function draw(){
      resetStates();
      root.querySelectorAll("[data-axm-tier]").forEach(function(el){
        var n=Number(el.dataset.axmTier),active=n===tier;
        el.classList.toggle("is-active",active);
        el.setAttribute("aria-pressed",active?"true":"false");
      });
      quantityWrap.hidden=tier!==5;
      quantityWrap.querySelector("output").textContent=String(currentQty);
      rows.innerHTML=selectStates.map(function(v,i){
        if(!list[v.kind].some(function(z){return String(z.id)===String(v.id)}))v.id=list[v.kind][0].id;
        return '<div class="axm-pair"><div class="axm-pair-title">세트 '+(i+1)+'</div>'+
        '<div class="axm-pair-fields"><label><span class="axm-label">렌즈 종류</span><select class="axm-select" data-kind="'+i+'">'+
        typeOptions.map(function(t){return '<option value="'+t.value+'"'+(v.kind===t.value?" selected":"")+'>'+esc(t.label)+'</option>'}).join("")+
        '</select></label><label><span class="axm-label">렌즈 도수 (SPH)</span><select class="axm-select" data-power="'+i+'">'+powers(v.kind,v.id)+'</select></label></div></div>';
      }).join("");
      totalEl.textContent=currency(price());
      compareEl.textContent=currency(currentQty*4999);
      var originalCents=currentQty*4999;
      var savingsCents=Math.max(0,originalCents-price());
      root.querySelector("[data-axm-save-amount]").textContent=currency(savingsCents);
      root.querySelector("[data-axm-save-pct]").textContent=Math.round(savingsCents/originalCents*100)+"%";
      status.textContent="";
    }
    root.addEventListener("change",function(event){
      var el=event.target,idx;
      if(el.matches("[data-kind]")){idx=Number(el.dataset.kind);selectStates[idx]={kind:el.value,id:list[el.value][0]?.id||null};draw();}
      if(el.matches("[data-power]")){idx=Number(el.dataset.power);selectStates[idx].id=Number(el.value);}
    });
    root.querySelectorAll("[data-axm-tier]").forEach(function(btn){
      btn.addEventListener("click",function(){
        tier=Number(btn.dataset.axmTier);currentQty=tier===5?Math.max(5,currentQty):tier;
        if(tier!==5)currentQty=tier;
        draw();
      });
    });
    root.querySelector("[data-axm-less]").addEventListener("click",function(){currentQty=Math.max(5,currentQty-1);draw()});
    root.querySelector("[data-axm-more]").addEventListener("click",function(){currentQty=Math.min(30,currentQty+1);draw()});
    async function submitBundle(destination){
      if(adding)return;
      try{
        if(selectStates.length!==currentQty)throw Error("각 세트의 렌즈 도수를 선택해 주세요.");
        var grouped={},valid=true;
        selectStates.forEach(function(x){
          if(!list[x.kind].some(function(v){return v.id===Number(x.id)})){valid=false;return}
          grouped[x.id]=(grouped[x.id]||0)+1;
        });
        if(!valid)throw Error("각 세트에서 유효한 SPH 도수를 선택해 주세요.");
        var items=Object.entries(grouped).map(function(x){return {id:Number(x[0]),quantity:x[1]}});
        adding=true;
        submit.disabled=true;
        buyNow.disabled=true;
        submit.textContent="추가 중…";
        buyNow.textContent="추가 중…";
        status.textContent="";
        var base=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||"/";
        var response=await fetch(base+"cart/add.js",{
          method:"POST",headers:{"Content-Type":"application/json","Accept":"application/json"},
          credentials:"same-origin",body:JSON.stringify({items:items})
        });
        if(!response.ok){
          var errorInfo=await response.json().catch(function(){return {}});
          throw Error(errorInfo.description||errorInfo.message||"번들을 장바구니에 추가하지 못했습니다. 다시 시도해 주세요.");
        }
        window.location.assign(base+(destination==="checkout"?"checkout":"cart"));
      }catch(err){
        status.textContent=String(err.message||err);
        adding=false;
        submit.disabled=false;
        buyNow.disabled=false;
        submit.textContent="장바구니 담기";
        buyNow.textContent="바로 구매";
      }
    }
    submit.addEventListener("click",function(){submitBundle("cart")});
    buyNow.addEventListener("click",function(){submitBundle("checkout")});
    draw();
    var sticky=document.getElementById("axm-sticky");
    if(sticky){sticky.querySelector("button").addEventListener("click",function(){root.scrollIntoView({behavior:"smooth",block:"center"})});
      if("IntersectionObserver" in window){var observer=new IntersectionObserver(function(entries){var visible=entries[0]?.isIntersecting;sticky.classList.toggle("is-visible",!visible&&window.scrollY>600)},{threshold:.1});observer.observe(root)}
    }
  }
  if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",init);else init();
  document.addEventListener("shopify:section:load",init);
})();